import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import buttonStyles from '../../components/Button/Button.module.scss'

const EVENT_FILTERS_BOX_DISMISSED_KEY = 'eventFiltersBoxDismissed'

export const EventFiltersBox: React.FC = () => {
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(EVENT_FILTERS_BOX_DISMISSED_KEY) !== 'true'
  })

  const handleDismiss = () => {
    localStorage.setItem(EVENT_FILTERS_BOX_DISMISSED_KEY, 'true')
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className='d-flex align-items-center justify-content-between gap-4 bg-light border rounded p-3 mb-4'>
      <div className='d-flex align-items-center gap-3'>
        <i className='bi bi-calendar2-week fs-4 text-dark flex-shrink-0' />
        <div>
          <span className='fw-normal'>
            <strong>Customize what meetings show here</strong>
          </span>
          <span className='fw-normal d-block'>Event Filters let you control which calendar events appear in this list.</span>
        </div>
      </div>
      <div className='d-flex align-items-center gap-4 flex-shrink-0'>
        <NavLink className={`${buttonStyles.button} ${buttonStyles.darkGhostButton}`} to={'/account/profile-settings/meeting-assistant'}>
          <strong>Open Event Filters</strong>
        </NavLink>
        <button type='button' className='btn-close' aria-label='Close' onClick={handleDismiss} />
      </div>
    </div>
  )
}
